'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 0;\n  hieght: 0;\n  z-index: 40;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,0.5);\n  opacity: 0;\n  pointer-events: none;\n  aside {\n    pointer-events: auto;\n  }\n  &.active {\n    opacity: 1;\n    width: 100vw;\n    height: 100vh;\n  }\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 0;\n  hieght: 0;\n  z-index: 40;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,0.5);\n  opacity: 0;\n  pointer-events: none;\n  aside {\n    pointer-events: auto;\n  }\n  &.active {\n    opacity: 1;\n    width: 100vw;\n    height: 100vh;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: white;\n  font-size: 2rem;\n  text-shadow: black 2px 2px 4px;\n  cursor: pointer;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    color: gold;\n  }\n'], ['\n  color: white;\n  font-size: 2rem;\n  text-shadow: black 2px 2px 4px;\n  cursor: pointer;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    color: gold;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  background-color: white;\n  color: #333;\n  .fa {cursor: pointer}\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  background-color: white;\n  color: #333;\n  .fa {cursor: pointer}\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  position: relative;\n  background-color: #ccc;\n  width: 100px;\n  height: 1rem;\n  border: 1px solid #333;\n'], ['\n  position: relative;\n  background-color: #ccc;\n  width: 100px;\n  height: 1rem;\n  border: 1px solid #333;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 0;\n  background-color: darkgreen;\n  width: ', '%;\n  height: 1rem;\n'], ['\n  position: absolute;\n  left: 0;\n  background-color: darkgreen;\n  width: ', '%;\n  height: 1rem;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  .fa {margin-right: 1rem;}\n'], ['\n  cursor: pointer;\n  .fa {margin-right: 1rem;}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _backgroundNoise = require('./background-noise');

var _backgroundNoise2 = _interopRequireDefault(_backgroundNoise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var Dialog = _styledComponents2.default.aside(_templateObject2);

var CloseButton = _styledComponents2.default.div(_templateObject3);

var Controls = _styledComponents2.default.div(_templateObject4);

var Slider = _styledComponents2.default.div(_templateObject5);

var Indicator = _styledComponents2.default.div(_templateObject6);

var Bar = _styledComponents2.default.div(_templateObject7, function (params) {
  return params.value * 100;
});

var InputGroup = _styledComponents2.default.div(_templateObject8);

/** @class sound
  * A component for controlling sounds in an expo.
  * @prop {URLString} backgroundNoise (optional) - an audio file to load and play
  */

var Sound = function (_Component) {
  _inherits(Sound, _Component);

  /** @constructor
    * Creates the sound component.
    */
  function Sound(props) {
    _classCallCheck(this, Sound);

    var _this = _possibleConstructorReturn(this, (Sound.__proto__ || Object.getPrototypeOf(Sound)).call(this, props));

    _this.state = {
      visible: false,
      volume: 0.15,
      muteBackgroundNoise: false,
      shush: false
    };
    _this.louder = _this.louder.bind(_this);
    _this.softer = _this.softer.bind(_this);
    _this.toggleMute = _this.toggleMute.bind(_this);
    // Synch with firebase cached settings
    if (window.vexpo.firebase && window.vexpo.firebase.auth().currentUser) {
      var uid = window.vexpo.firebase.auth().currentUser.uid;
      _this.firebaseRef = window.vexpo.firebase.database().ref('/settings/' + uid);
      _this.firebaseRef.once('value', function (snapshot) {
        _this.setState(snapshot.val());
      });
    }
    return _this;
  }
  /** @method componentWillMount
    * Sets up the sound api in the global vexpo object.
    */


  _createClass(Sound, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (!window.vexpo) window.vexpo = {};
      window.vexpo.sound = {
        showVolume: function showVolume() {
          return _this2.setState({ visible: true });
        },
        volume: function volume() {
          return _this2.state.volume;
        },
        shush: function shush() {
          return _this2.setState({ shush: true });
        },
        unshush: function unshush() {
          return _this2.setState({ shush: false });
        }
      };
    }
    /** @method louder
      * Increases the expo volume.
      */

  }, {
    key: 'louder',
    value: function louder() {
      var volume = this.state.volume;
      volume += 0.1;
      if (volume > 1) volume = 1;
      this.setState({ volume: volume });
      if (this.firebaseRef) this.firebaseRef.child('volume').set(volume);
    }
    /** @method softer
      * Decreases the expo volume.
      */

  }, {
    key: 'softer',
    value: function softer() {
      var volume = this.state.volume;
      volume -= 0.1;
      if (volume < 0) volume = 0;
      this.setState({ volume: volume });
      if (this.firebaseRef) this.firebaseRef.child('volume').set(volume);
    }
    /** @method toggleMute
      * Toggles the (user-controlled) background noise muting
      */

  }, {
    key: 'toggleMute',
    value: function toggleMute() {
      var _this3 = this;

      this.setState({ muteBackgroundNoise: !this.state.muteBackgroundNoise }, function () {
        if (_this3.firebaseRef) _this3.firebaseRef.child('muteBackgroundNoise').set(_this3.state.muteBackgroundNoise);
      });
    }
    /** @method render
      * Renders the component
      */

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        Wrapper,
        { className: this.state.visible ? 'active' : '' },
        _react2.default.createElement(_backgroundNoise2.default, {
          src: this.props.backgroundNoise,
          volume: this.state.volume,
          mute: this.state.muteBackgroundNoise || this.state.shush
        }),
        _react2.default.createElement(
          Dialog,
          null,
          _react2.default.createElement(
            CloseButton,
            { onClick: function onClick() {
                return _this4.setState({ visible: false });
              } },
            'CLOSE',
            _react2.default.createElement(_reactFontawesome2.default, { name: 'times' })
          ),
          _react2.default.createElement(
            Controls,
            null,
            'VOLUME',
            _react2.default.createElement(
              Slider,
              null,
              _react2.default.createElement(
                'button',
                { onClick: this.softer },
                _react2.default.createElement(_reactFontawesome2.default, { name: 'volume-down', size: '2x' })
              ),
              _react2.default.createElement(
                Indicator,
                null,
                _react2.default.createElement(Bar, { value: this.state.volume })
              ),
              _react2.default.createElement(
                'button',
                { onClick: this.louder },
                _react2.default.createElement(_reactFontawesome2.default, { name: 'volume-up', size: '2x' })
              )
            ),
            _react2.default.createElement(
              InputGroup,
              { onClick: this.toggleMute },
              _react2.default.createElement(_reactFontawesome2.default, { name: this.state.muteBackgroundNoise ? 'check-square' : 'square' }),
              'Mute Background Noise'
            )
          )
        )
      );
    }
  }]);

  return Sound;
}(_react.Component);

exports.default = Sound;


Sound.propTypes = {
  backgroundNoise: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/sound/sound.js
// module id = 1353
// module chunks = 0